import Stack from '@mui/material/Stack';
import type { ChoiceSelectorProps } from '@components/Checkout/steps/PhoneNumberStep/PhoneNumberStep.types';
import RadioGroupSet from '@shared/components/inputs/Radio/RadioGroupSet';
import TextFieldLabel from '@shared/components/inputs/TextFieldLabel/TextFieldLabel';

const CHOICE_OPTIONS = [
  { value: 'NEWNUMBER', label: 'I Need a New Phone Number' },
  { value: 'PORTIN', label: 'I Want to Use My Existing Phone Number' },
] as const;

export const ChoiceSelector = ({ value, onChange }: ChoiceSelectorProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange((e.target as HTMLInputElement).value as ChoiceSelectorProps['value']);
  };

  return (
    <Stack gap="8px">
      <TextFieldLabel label="Select Phone Number Option" />
      <RadioGroupSet value={value} onChange={handleChange} options={[...CHOICE_OPTIONS]} gap="4px" />
    </Stack>
  );
};
